import Styles from "./BottomOptions.module.scss";
import classnames from "classnames"

interface BottomOptionsProps{
    activeTabId:any;
    contentArray:any;
    onOptionClick:(data:any)=>void;
}

const BottomOptions = ({activeTabId,contentArray,onOptionClick}:BottomOptionsProps) => {
  return (
    <div className={Styles.container}>
      {
        contentArray.map((option:any)=>{
            return(
                <div className={classnames(Styles.option,activeTabId===option.id && Styles.active)} onClick={()=>{onOptionClick(option.id)}} key={option.id} >
                    <div className={Styles.icon}>
                        {option.icon}
                    </div>
                    <div className={Styles.label}>
                        {option.label}
                    </div>
                </div>
            )
        })
      }
    </div>
  )
}

export default BottomOptions
